import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import IrqChoiceButtons from "../molecules/IrqChoiceButtons";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import ILearn from "../molecules/ILearn";

const VALUES = [true, false];

const navigationCallback = ({ navigationsAway, values, index }) => {
  const foundIndex =
    typeof index !== "undefined"
      ? index
      : VALUES.findIndex((v) => v === values.takeCashOut);

  return foundIndex === 0 ? navigationsAway.Primary : navigationsAway.Secondary;
};

class REFINANCEIRQTakeCashOutView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle content={this.props.content} />
          <IrqChoiceButtons
            content={this.props.content}
            value={this.props.data.takeCashOut}
            values={VALUES}
            onChoiceMade={(index) => {
              if (index === 0) {
                this.props.customFormEdit("takeCashOut", true);
                this.props.customFormEdit("cashOutAmount", 0);
                this.props.customFormEdit("lookingTo", "RefinanceAndCashOut");
              } else {
                this.props.customFormEdit("takeCashOut", false);
                this.props.customFormEdit("cashOutAmount", 0);
                this.props.customFormEdit("lookingTo", "Refinance");
              }

              const navigateTo = navigationCallback({ index, ...this.props });

              this.props.navigationContext.goNext(navigateTo, true);
            }}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(
  connect()(REFINANCEIRQTakeCashOutView),
  navigationCallback
);
